import Vue from 'vue'
import optionData from '@/optionData/data'
import {ko} from 'vuejs-datepicker/dist/locale'
export const Tooltip = Vue.extend({
  name : 'tooltip',
  template: `
    <div class="cellCenter">
      <vx-tooltip :text="text" position="top" >
        <vs-button class="btnSmall" color="rgb(95 95 95)">{{title}}</vs-button>
      </vx-tooltip> 
    </div>
    `,
  data(){
    return{
      title : '',
      text : '',
      style : '',
    }
  },
  created(){
    this.title = this.params.title ? this.params.title : null
    this.text  = this.params.text ? this.params.text : 'null'
    this.style  = this.params.style ? this.params.style : ''
  },
  methods: {
    btnClickedHandler() {
      this.params.clicked(this.params.data);
    }
  },
});
export const TooltipCustom = Vue.extend({
  name : 'tooltipCustom',
  template: `
    <div class="cellCenter">
      <vx-tooltip :text="text" position="top" >
        <div v-html="html"> </div>
      </vx-tooltip> 
    </div>
    `,
  data(){
    return{
      title : '',
      text : '',
      style : '',
      html : null,
    }
  },
  created(){
    this.title = this.params.title ? this.params.title : null
    this.text  = this.params.text ? this.params.text : null
    this.style  = this.params.style ? this.params.style : ''
    this.html  = this.params.html ? this.params.html : ''
  },
  methods: {
    btnClickedHandler() {
      this.params.clicked(this.params.data);
    }
  },
});
export const HtmlCustom = Vue.extend({
  name : 'tooltipCustom',
  template: `
    <div class="cellCenter" v-html="html">
      
    </div>
    `,
  data(){
    return{
      html : null,
    }
  },
  created(){
 
    this.html  = this.params.html ? this.params.html : ''
  },
  methods: {
    btnClickedHandler() {
      this.params.clicked(this.params.data);
    }
  },
});
export const TextButton = Vue.extend({
  name : 'textButton',
  template: `
     <div class="cellCenter"  @click="btnClickedHandler()" :style="style"><div v-html="text"></div></div>
    `,
  data(){
    return{
      title : '',
      text : '',
      style : '',
    }
  },
  created(){
    this.title = this.params.colDef.headerName
    this.text  = this.params.text ? this.params.text : ''
    this.style  = this.params.style ? this.params.style : ''
  },
  methods: {
    btnClickedHandler() {
      this.params.clicked(this.params.data);
    }
  },
});
export const TextButton2 = Vue.extend({
  name : 'textButton',
  template: `
     <div class="cellCenter">
      <div @click="btnClickedHandler()" :style="style" v-html="text"></div>
      <div @click="btnClickedHandler2()" :style="style" v-html="text2"></div>
     </div>
    `,
  data(){
    return{
      title : '',
      text : '',
      text2 : '',
      style : '',
    }
  },
  created(){
    this.title = this.params.colDef.headerName
    this.text  = this.params.text ? this.params.text : null
    this.text2  = this.params.text2 ? this.params.text2 : null
    this.style  = this.params.style ? this.params.style : ''
  },
  methods: {
    btnClickedHandler() {
      this.params.clicked(this.params.data);
    },
    btnClickedHandler2() {
      this.params.clicked2(this.params.data);
    }
  },
});
export const TextRender = Vue.extend({
    name : 'textRender',
    template: `
       <div class="cellCenter" ><span :style="style" v-html="text"></span></div>
      `,
    data(){
      return{
        title : '',
        text : '',
        style : '',
      }
    },
    created(){
      this.title = this.params.colDef.headerName
      this.text  = this.params.text ? this.params.text : ''
      this.style  = this.params.style ? this.params.style : ''
    },
    methods: {
     
    },
});
export const TextLink = Vue.extend({
  name : 'textLink',
  template: `
     <div class="cellCenter" :style="style">
      <router-link
        class="blueText"
        :to="url"
        :target="target" >
        {{title?title : ''}}
      </router-link>
     </div>
    `,
  data(){
    return{
      title : '',
      text : '',
      style : '',
      url : null,
    }
  },
  created(){
    this.title = this.params.colDef.headerName
    this.text  = this.params.text ? this.params.text : 'null'
    this.style  = this.params.style ? this.params.style : ''
    this.url = this.params.url ? this.params.url : null
    this.target = this.params.target ? this.params.target : ''
  },
  methods: {
   
  },
});
export const BtnSelect = Vue.extend({
    name : 'btnSelect',
    template: `
        <div class="cellCenter">
          <vs-button :disabled="disabled" class="btnSmall button" style="z-index :1; min-width:80px;" @click.native="btnClickedHandler()" :color="color" type="filled">
            <span class="button" v-html="title"></span>
          </vs-button> 
        </div>
      `,
    data(){
      return{
        title : '',
        color : 'primary',
        disabled : false
      }
    },
    created(){
      this.title = this.params.title ? this.params.title : '선택'
      this.color = this.params.color? this.params.color : 'primary'
      this.disabled = this.params.disabled? this.params.disabled : false
    },
    methods: {
      btnClickedHandler() {
        this.params.clicked(this.params.data);
      }
    },
});
export const BtnDelete = Vue.extend({
  name : 'btnDelete',
  template: `
      <div class="flex items-center" style="line-height:1.6; height:100%;">
            
          <vs-button style="width:70px;" color="danger" class="btnSmall" @click="btnClickedHandler2()" >삭제</vs-button> 
      </div>
    `,
  data(){
    return{
      title : ''
    }
  },
  created(){
    this.title = this.params.colDef.headerName
  },
  methods: {
    btnClickedHandler() {
      this.params.clicked(this.params.data);
    },
    btnClickedHandler2() {
      this.params.clicked2(this.params.data);
    }
  },
});
export const TextInput = Vue.extend({
    name : 'textInput',
    template: `
          <div class="flex items-center" style="line-height:1.6; height:100%;">
              <vs-input class="vx-col w-full mr-2"  :placeholder="title" v-model="editValue" />
              <vs-button style="width:70px;;" class="btnSmall" @click="btnClickedHandler()" >수정</vs-button> 
          </div>
      `,
    data(){
      return{
          editValue : null,
          title : '',
          text : '',
          mode : false,
      }
    },
    created(){
      this.title = this.params.colDef.headerName
      this.text  = this.params.text ? this.params.text : '선택'
    },
    methods: {
      btnClickedHandler() {
        if(this.valCheck(this.editValue)){
          this.alert({msg: '값을 입력해주세요.'})
          return false
        }
        this.mode = !this.mode
        this.params.clicked({
            ...this.params.data,
            editValue : this.editValue
        });
      },
    },
});
export const dateSelect = Vue.extend({
  name : 'dateSelect',
  template: `
    <div class="flex items-center" style="line-height:1.6; height:100%;">
      <datepicker 
        class="vx-col w-full"
        placeholder="yyyy-mm-dd" 
        v-model="editValue"
        :value="editValue"
        @input="editValue = fixDate($event,'yyyy-MM-dd')"
        format="yyyy-MM-dd"
        :language="ko"
        :clear-button='true'
      />
      <vs-button style="width:70px; " class="btnSmall ml-2" @click="btnClickedHandler()" >수정</vs-button> 
    </div>
    
  `,
  data(){
    return{
        ko : ko,
        editValue : null,
        title : '',
        text : '',
        mode : false,
    }
  },
  created(){
    this.title = this.params.colDef.headerName
    this.text  = this.params.text ? this.params.text : '선택'
  },
  methods: {
    btnClickedHandler() {
      if(this.valCheck(this.editValue)){
        this.alert({msg: '날짜를 선택해주세요.'})
        return false
      }
      this.mode = !this.mode
      this.params.clicked({
          ...this.params.data,
          editValue : this.editValue
      });
    },
  },
});
export const SelectBox = Vue.extend({
    name : 'selectBox',
    template: `
        
        <div class="flex items-center" style="line-height:1.6; height:100%;">
            <v-select
                style="min-width:200px;"
                placeholder="" 
                :value="optionValue" 
                v-model='optionValue' 
                :options="optionList"
                :reduce="optionList => optionList.value"
                :clearable="false" 
                :disabled="disabled"
                >
                
            </v-select>
          <vs-button v-if="!disabled" style="width:70px; " class="btnSmall ml-2" @click="btnClickedHandler()" >수정</vs-button> 
        </div>
      `,
    data(){
      return{
          editValue : null,
          title : '',
          text : '',
          mode : false,
          optionValue : null ,
          disabled: false, 
          optionList : [
             
          ]
      }
    },
    watch :{
        'params.context.componentParent.cellOptionList'(data){
            this.optionList  = this.params.context.componentParent.cellOptionList 
        }
    },
    created(){
        this.$emit('sendoper',(data)=>{
            console.log(data)
        })
        this.optionList  = this.params.context.componentParent.cellOptionList 
        this.disabled  = this.params.disabled ? this.params.disabled : false

    },
    methods: {
      btnClickedHandler() {
          this.mode = !this.mode
          this.params.clicked({
              ...this.params.data,
              editValue : this.optionValue
          });
      }
    },
});
export const SelectBoxEdit = Vue.extend({
    name : 'selectBoxEdit',
    template: `
        <div class="cellCenter">
            <v-select
                label="name"
                placeholder="" 
                :value="optionValue" 
                v-model='optionValue' 
                :options="optionList"
                :reduce="optionList => optionList.code"
                :clearable="false" 
                :disabled="disabled"
                >
            </v-select>
        </div>
      `,
    data(){
      return{
        editValue : null,
        title : '',
        text : '',
        mode : false,
        optionValue : null ,
        optionList : [],
        disabled: false,
        
      }
    },
    created(){
        this.optionList  = this.params.optionList ?  this.params.optionList : []

    },
    methods: {
      btnClickedHandler() {
          this.mode = !this.mode
          this.params.clicked({
              ...this.params.data,
              editValue : this.optionValue
          });
      }
    },
});
export const SelectBoxCountry = Vue.extend({
    name : 'selectBoxCountry',
    template: `
      <div class="flex items-center" style="line-height:1.6; height:100%;">
        <v-select
        style="min-width:150px"
        label="name"
        placeholder="국가선택" 
        :value="editValue" 
        v-model='editValue' 
        :options="countryOption"
        :reduce="countryOption => countryOption.code"
        :clearable="false" 
        :disabled="disabled"
        />
        
      <vs-button v-if="!disabled" style="width:70px; " class="btnSmall ml-2" @click="btnClickedHandler()" >수정</vs-button> 
    </div>
      `,
    data(){
      return{
        editValue : null,
        title : '',
        text : '',
        mode : false,
        country : null ,
        countryOption : optionData.country,
        disabled: false,
      }
    },
    created(){
        
        this.editValue = typeof this.params.code != 'undefined' ? String(this.params.code) : null
        this.disabled  = this.params.disabled ? this.params.disabled : false
    },
    methods: {
      btnClickedHandler() {
          this.mode = !this.mode
          this.params.clicked({
              ...this.params.data,
              editValue : this.editValue
          });
      }
    },
});
export const MusicStore = Vue.extend({
    name : 'musicStore',
    template: `
        <div class="cellCenter">
            <div class="flex items-center mt-1" style="line-height:1.6; height:100%">
                <v-select
                    class=" mr-2"
                    style="width:160px;"
                    label="name"
                    placeholder="운영사" 
                    :value="operation" 
                    v-model='operation' 
                    :options="optionList"
                    :reduce="optionList => optionList.id"
                    :clearable="false" 
                    >
                </v-select>
                <v-select
                    class=" mr-2"
                    style="width:100px;"
                    label="name"
                    placeholder="유통그룹" 
                    :value="group" 
                    v-model='group' 
                    :options="groupList"
                    :reduce="groupList => groupList.value"
                    :clearable="false" 
                    >
                </v-select>
                <v-select
                    class=" mr-2"
                    style="width:100px;"
                    label="name"
                    placeholder="유통상태" 
                    :value="active" 
                    v-model='active' 
                    :options="activeList"
                    :reduce="activeList => activeList.value"
                    :clearable="false" 
                    >
                </v-select>
                <vs-input style="flex:1" class="vx-col w-full ml-2 mr-2"  placeholder="뮤직스토어명" v-model="display_name" />
                <vs-button style="width:70px; " class="btnSmall" @click="btnClickedHandler()" >수정</vs-button> 
            </div>
        </div>
      `,
    data(){
      return{
        title : '',
        text : '',
        display_name :null,
        optionList : [],
        operation: null,
        active : null,
        activeList : [
            {name : 'active' ,value: true},
            {name : 'inactive' ,value: false},
        ],
        group : null,
        groupList : [
          {name : '한국' ,value: 'korea'},
          {name : '해외' ,value: 'other'},
        ]
      }
    },
    watch :{
        'params.context.componentParent.cellOptionList'(data){
            this.optionList  = this.params.context.componentParent.cellOptionList 
        }
    },
    created(){
        this.$emit('sendoper',(data)=>{
            console.log(data)
        })
        this.optionList  = this.params.context.componentParent.cellOptionList 
    },
    methods: {
      btnClickedHandler() {
        if(this.valCheck(this.operation) || this.valCheck(this.group) || this.active == null || this.valCheck(this.display_name) ){
          this.alert({msg : '운영사, 유통그룹, 유통상태, 뮤직스토어명을 모두 입력해주세요.'})
          return false
        }
        this.params.clicked({
            ...this.params.data,
            operation : this.operation,
            group : this.group,
            active: this.active, 
            display_name : this.display_name,
        });
      }
    },
});
export const ServiceBtn = Vue.extend({
    //[‘ST’, ‘DL’, ‘OTHER’]
    name : 'serviceBtn',
    template: `
      <div class="cellCenter">
        <div class="flex">
        
          <vs-button @click="btnClickedHandler('ST')" :type="optionValue != 'ST' ?  'border' : 'filled'">Streaming</vs-button>
          <vs-button class="ml-2" @click="btnClickedHandler('DL')"  :type="optionValue != 'DL' ?  'border' : 'filled'">Download</vs-button>
          <vs-button class="ml-2" @click="btnClickedHandler('OTHER')" :type="optionValue != 'OTHER' ?   'border' : 'filled'">Other</vs-button>
        </div>
      </div>
    `,
    data(){
      return{    
        optionValue : null ,
        mode : null
      }
    },
    created(){
      
        this.optionList  = this.params.optionList ?  this.params.optionList : []
        

    },
    methods: {
      btnClickedHandler(val) {
          this.optionValue = val
          this.mode = !this.mode
          this.params.clicked({
              ...this.params.data,
              optionValue : this.optionValue
          });
      }
    },
});
export const Compare = Vue.extend({
  name : 'compare',
  template: `
    <div style="height:100%;">
    <div style="height:50%;" class="log" v-html="html1"></div>
    <div style="height:50%;" class="srd" v-html="html2"></div>
    </div>
  `,
  data(){
    return{    
      optionValue : null ,
  
    }
  },
  created(){
      this.html1  = this.params.html1 ?  this.params.html1 : ''
      this.html2  = this.params.html2 ?  this.params.html2 : ''

  },
  methods: {
    btnClickedHandler(val) {

      this.optionValue = val
      this.mode = !this.mode
      this.params.clicked({
          ...this.params.data,
          optionValue : this.optionValue
      });
    }
  },
});
export const albumTrackAction = Vue.extend({
  name : 'albumTrackAction',
  template: `
    <div class="cellCenter" style="align-items:center" >
      <p class="textCenter mb-2">{{text}} </p>
      <div class="flex">
      
          <vs-button style="font-size:13px; padding: 5px 10px !important;white-space: nowrap;" v-if="mode && text == null" @click="btnClickedHandler('ok-match')" class="btnMedium" color="success" >정상 매칭</vs-button>
          <vs-button style="font-size:13px; padding: 5px 10px !important;white-space: nowrap;" @click="btnClickedHandler('match')" class="btnMedium ml-2" >재매칭</vs-button>
          <vs-button style="font-size:13px; padding: 8px 12px !important; white-space: nowrap;" @click="btnClickedHandler('reject')" class="btnMedium ml-2" color="danger" >정산미반영</vs-button>
      </div>
    </div>
  `,
  data(){
    return{    
      optionValue : null ,
      mode : true,
      text : null
        
    }
  },
  created(){
      this.optionList  = this.params.optionList ?  this.params.optionList : []
      this.mode  = !this.params.mode ?  this.params.mode : true
      this.text = this.params.text == 'OK_MATCH' ? '정상매칭'  : this.params.text == 'RE_MATCH'? '재매칭'  : this.params.text == 'IGNORE'?  '정산미반영'  : null
  },
  methods: {
    btnClickedHandler(val) {
        
       
        this.params.clicked({
            ...this.params.data,
            selectIndex : this.params.node.childIndex,
            optionValue : this.optionValue,
            type : val
        });
    }
  },
});
// 데이터검수 - 권리자 정산화폐 환전 로그 선택 체크박스
export const transferCheckBox = Vue.extend({
  name : 'checkBox',
  template: `

      <vs-checkbox class="inline-flex mt-2" v-model="check"></vs-checkbox>
    `,
  data(){
    return{
      check : false,
      value : {},
      disabled : false
    }
  },
  watch :{
    'check'(e){
      this.btnClickedHandler()
      let a = this.params.context.componentParent.checkList
      const idx = a.findIndex((item) => {return item.id === this.value.id})
      if(e == true){
        if(idx < 0){
          this.params.context.componentParent.checkList.push(this.value);
        }
      }else{
        this.params.context.componentParent.checkList.splice(idx,1)
      }
      console.log(this.params.context.componentParent.checkList)
    }
  },
  
  created(){
    let t = this.params.context.componentParent.checkList
    this.value = this.params.data
    for(var i in t){
      if(t[i].id == this.value.id){
        this.check = true
      }
    }
  },
  methods: {
    btnClickedHandler() {
      this.params.clicked(this.params.data);
    }
  },
});
export const exchangeText = Vue.extend({
  name : 'checkBox',
  template: `
        <div class="cellCenter textRight" style="
        flex-direction: row;
        justify-content: space-between;
        align-items: center;">
        <div style="width:33.3%; padding:0 50px 0 0; text-align:left">
            <div v-if="salesAmountData['krw']['exchanged_at']">
              <vx-tooltip :text="'환전대상금액  : '+ numberFormat(salesAmountData['krw']['amount']) +'KRW  <br/>  ' + '     2차환전환율 : 1KRW = ' + numberFormat(salesAmountData['krw']['exchange_rate']) +'KRW '" position="top" >
                
                <p >{{ numberFormat( salesAmountData['krw']['exchange_amount'])}} KRW</p>
                    
                <p class="green">2차환전일 : {{this.fixDate(salesAmountData['krw']['exchanged_at'])}}</p>
                <p v-if="salesAmountData['krw'].open_state == 'open_complete'" class="blue">정산공개 
                  {{this.fixDate(salesAmountData['krw']['opened_at'])}}
                </p>
                <p v-else-if="salesAmountData['krw'].open_state == 'open_processing'" class="blue">정산공개 : 처리중</p> 
                <p v-else class="blue">정산공개 : 비공개</p>
              </vx-tooltip> 
            </div>
            <div class="green" v-else-if="salesAmountData['krw'].open_state =='exchange_processing'">KRW 환전 처리중</div>
            <div v-else>KRW 미환전</div>
        </div>
        <div style="width:33.3%; padding:0 50px 0 0; text-align:left">
            <div v-if="salesAmountData['usd']['exchanged_at']">
              <vx-tooltip :text="'환전대상금액  : '+ numberFormat(salesAmountData['usd']['amount']) +'KRW    <br/> ' + '         2차환전환율 : 1USD = ' + numberFormat(salesAmountData['usd']['exchange_rate']) +'KRW '" position="top" >
                
                <p>{{ numberFormat( salesAmountData['usd']['exchange_amount'])}} USD</p>
                    
                <p class="green">2차환전일 : {{this.fixDate(salesAmountData['usd']['exchanged_at'])}}</p>
                <p v-if="salesAmountData['usd'].open_state == 'open_complete'" class="blue">정산공개 
                  {{this.fixDate(salesAmountData['usd']['opened_at'])}}
                </p>
                <p v-else-if="salesAmountData['usd'].open_state == 'open_processing'" class="blue">정산공개 : 처리중</p> 
                <p v-else class="blue">정산공개 : 비공개</p>
              </vx-tooltip> 
            </div>
            <div class="green" v-else-if="salesAmountData['usd'].open_state =='exchange_processing'">USD 환전 처리중</div>
            <div v-else>USD 미환전</div>
        </div>
        <div style="width:33.3%; padding:0 50px 0 0; text-align:left">
            <div v-if="salesAmountData['eur']['exchanged_at']">
              <vx-tooltip :text="'환전대상금액  : '+ numberFormat(salesAmountData['eur']['amount']) +'KRW     <br/>      ' + '       2차환전환율 : 1EUR = ' + numberFormat(salesAmountData['eur']['exchange_rate']) +'KRW '" position="top" >
                
                <p>{{ numberFormat( salesAmountData['eur']['exchange_amount'])}} EUR</p>
                    
                <p class="green">2차환전일 : {{this.fixDate(salesAmountData['eur']['exchanged_at'])}}</p>
                <p v-if="salesAmountData['eur'].open_state == 'open_complete'" class="blue">정산공개 
                  {{this.fixDate(salesAmountData['eur']['opened_at'])}}
                </p>
                <p v-else-if="salesAmountData['eur'].open_state == 'open_processing'" class="blue">정산공개 : 처리중</p> 
                <p v-else class="blue">정산공개 : 비공개</p>
              </vx-tooltip> 
            </div>
            <div class="green" v-else-if="salesAmountData['eur'].open_state =='exchange_processing'">EUR 환전 처리중</div>
            <div v-else>EUR 미환전</div>
        </div>
      </div>
    `,
  data(){
    return{
      check : false,
      value : {},
      salesAmountData : {
        krw:{
            amount : 0,
            exchange_amount: 0,
            open_state: "processing"
        },
        usd:{
            amount : 0,
            exchange_amount: 0,
            
            open_state: "processing"
        },
        eur:{
            amount : 0,
            exchange_amount: 0,
            open_state: "processing"
        }
      }
    }
  },
  watch :{
    
  },
  
  created(){
    this.salesAmountData  = this.params.salesAmountData ?  this.params.salesAmountData : {}
  },
  methods: {
    
  },
});
const agTableComp = {
    "htmlCustom" : HtmlCustom,
    'textButton': TextButton,
    'textButton2' : TextButton2 ,
    'textLink' : TextLink ,
    'textRender' : TextRender,
    'btnSelect' : BtnSelect,
    'btnDelete' : BtnDelete,
    'textInput':TextInput,
    'selectBox':SelectBox,
    'selectBoxCountry':SelectBoxCountry,
    'selectBoxEdit':SelectBoxEdit,
    'musicStore':MusicStore,
    'serviceBtn' :ServiceBtn,
    'compare' :Compare,
    'albumTrackAction' : albumTrackAction,
    'transferCheckBox':transferCheckBox,
    'dateSelect' : dateSelect,
    'exchangeText' : exchangeText,
    'tooltip' : Tooltip,
    'tooltipCustom' : TooltipCustom
} 
export default agTableComp